module.exports = __webpack_public_path__ + "static/clients-foursisters.bd88c258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/clients-foursisters.png
// module id = 928
// module chunks = 241767136424496